
import { useStore } from "../../state/state.ts";
import Statistics from "../statistics.tsx";
export default function StatisticsProduktionSolarstrom() {
  const annual_pv_production_kwh_adjusted = useStore((state)=>state.annual_pv_production_kwh_adjusted ?? 0);
  const annual_pv_production_kwh_planned = useStore((state)=>state.annual_pv_production_kwh_planned ?? 0);
  const pv_hint = useStore((state)=>state.pv_hint ?? "");

  if (annual_pv_production_kwh_adjusted == 0 && annual_pv_production_kwh_planned == 0){return <></>;}
  return (
    <Statistics label={"Produktion PV-Strom"} now={annual_pv_production_kwh_adjusted} future={annual_pv_production_kwh_planned} unit={"kwh/Jahr"} />
  )
}